export default __webpack_public_path__ + "static/media/fileDefaults.bd8dfd14.png";